// import Vue from 'vue'
// import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from  '@/components/home'
import login from '@/components/login'
import orderCheck from '@/components/orderCheck'
import dateCheck from '@/components/dateCheck'
import depotCheck from '@/components/depotCheck'
import orderDetail from '@/components/orderDetail'
import scanDetail from '@/components/scanDetail'
import codeDetail from '@/components/codeDetail'
import depotDetail  from '@/components/codeDetail'

// Vue.use(Router)

export default new VueRouter({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component:() => import('@/components/home'),
      meta:{
        requireAuth:true
      },
    },
    {
      path:'/login',
      name:'login',
      component:() => import('@/components/login'),
    },
    {
      path:'/orderCheck',
      name:'orderCheck',
      component:() => import('@/components/orderCheck'),
      meta:{
        requireAuth:true
      }
    },
    {
      path:'/dateCheck',
      name:'dateCheck',
      component:() => import('@/components/dateCheck'),
      meta:{
        requireAuth:true
      }
    },
    {
      path:'/depotCheck',
      name:'depotCheck',
      component:() => import('@/components/depotCheck'),
      meta:{
        requireAuth:true
      }
    },
    {
      path:'/orderDetail',
      name:'orderDetail',
      component:() => import('@/components/orderDetail'),
      meta:{
        requireAuth:true
      }
    },
    {
      path:'/scanDetail',
      name:'scanDetail',
      component:() => import('@/components/scanDetail'),
      meta:{
        requireAuth:true
      }
    },
    {
      path:'/codeDetail',
      name:'codeDetail',
      component:() => import('@/components/codeDetail'),
      meta:{
        requireAuth:true
      }
    },
    {
      path: '/depotDetail',
      name: 'depotDetail',
      component: () => import('@/components/depotDetail'),
      meta: {
        requireAuth: true
      }
    },
    {
      path:'/unCheckIn',
      name:'unCheckIn',
      component:() => import('@/components/unCheckIn'),
      meta:{
        requireAuth:true
      }
    },
    {
      path:'/sizeDetail',
      name:'sizeDetail',
      component:() => import('@/components/sizeDetail'),
      meta:{
        requireAuth:true
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js